import { sliderStyles } from "@ui/components/Slider/styles";
import {
  Slider as RACSlider,
  SliderFill as RACSliderFill,
  SliderThumb as RACSliderThumb,
  SliderTrack as RACSliderTrack,
} from "@ui/primitives/Slider";

export interface RangeSliderProps {
  "aria-label": string;
  className?: string;
  isDisabled?: boolean;
  maxValue: number;
  minValue: number;
  onChange?: (value: [number, number]) => void;
  onChangeEnd?: (value: [number, number]) => void;
  step?: number;
  /** Accessible names for the low/high thumbs — react-aria requires one per thumb. */
  thumbLabels: [string, string];
  value: [number, number];
}

export function RangeSlider({
  "aria-label": ariaLabel,
  className,
  isDisabled,
  maxValue,
  minValue,
  onChange,
  onChangeEnd,
  step,
  thumbLabels,
  value,
}: RangeSliderProps) {
  const styles = sliderStyles();

  return (
    <RACSlider
      aria-label={ariaLabel}
      className={styles.root({ className })}
      isDisabled={isDisabled}
      maxValue={maxValue}
      minValue={minValue}
      onChange={onChange && ((v) => onChange(v as [number, number]))}
      onChangeEnd={onChangeEnd && ((v) => onChangeEnd(v as [number, number]))}
      step={step}
      value={value}
    >
      <RACSliderTrack className={styles.track()}>
        <RACSliderFill className={styles.fill()} />
        <RACSliderThumb aria-label={thumbLabels[0]} className={styles.thumb()} index={0} />
        <RACSliderThumb aria-label={thumbLabels[1]} className={styles.thumb()} index={1} />
      </RACSliderTrack>
    </RACSlider>
  );
}
